import React from "react";
import { useOnboarding } from "../../../contexts/OnboardingContext";
import { Mascot, SelectableRow, StepHeading, ContinueButton, CtaRow, Item } from "../NOKit";

// iOS NOScreenTimeStep port. Inline stroke icons (no emoji) — the codebase
// has no icon library, so these are hand-drawn 24px strokes.
const strokeIcon = (color, paths) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {paths}
  </svg>
);

const ICONS = {
  youtube: strokeIcon("#E5484D", (
    <>
      <rect x="2.5" y="5" width="19" height="14" rx="4" />
      <path d="M10 9.5l5 2.5-5 2.5z" fill="#E5484D" stroke="none" />
    </>
  )),
  games: strokeIcon("#8A5CF6", (
    <>
      <path d="M6.5 6.5h11a4.5 4.5 0 014.4 5.4l-.9 4.5a2.8 2.8 0 01-4.9 1.2l-1.3-1.6h-5.6l-1.3 1.6a2.8 2.8 0 01-4.9-1.2l-.9-4.5a4.5 4.5 0 014.4-5.4z" />
      <path d="M8 10.5v3M6.5 12h3" />
      <circle cx="15.5" cy="11" r="0.6" fill="#8A5CF6" stroke="none" />
      <circle cx="17.5" cy="13" r="0.6" fill="#8A5CF6" stroke="none" />
    </>
  )),
  shows: strokeIcon("#2FB344", (
    <>
      <path d="M3 7h4.5c2 0 3.5 1 4.5 2.5C13 11 14.5 12 16.5 12H21" />
      <path d="M3 17h4.5c2 0 3.5-1 4.5-2.5 1-1.5 2.5-2.5 4.5-2.5H21" opacity="0.45" />
      <path d="M18.5 9.5L21 7l-2.5-2.5M18.5 19.5L21 17l-2.5-2.5" />
    </>
  )),
  better: strokeIcon("#E8A200", (
    <>
      <path d="M12 3.5l1.8 4.7 4.7 1.8-4.7 1.8L12 16.5l-1.8-4.7-4.7-1.8 4.7-1.8z" />
      <path d="M18.5 15.5l.9 2.1 2.1.9-2.1.9-.9 2.1-.9-2.1-2.1-.9 2.1-.9z" fill="#E8A200" stroke="none" />
    </>
  )),
};

export const SCREEN_TIME_OPTIONS = [
  { id: "youtube", iconBg: "#FFE3E3", title: "YouTube rabbit holes" },
  { id: "games", iconBg: "#EFE7FF", title: "Mindless game apps" },
  { id: "shows", iconBg: "#E0F7EA", title: "Random kids shows" },
  { id: "better", iconBg: "#FFF4D6", title: "Just want something better" },
];

const ScreenTimeStep = () => {
  const { screenTime, setScreenTime, nextStep } = useOnboarding();

  return (
    <>
      <Mascot clip="panda_point_2" />
      <StepHeading
        eyebrow="Screen time"
        title="What are we"
        accent="replacing?"
        subtitle="Pixley swaps the scroll for stories made just for your child."
      />
      <Item className="ob-options" role="radiogroup" aria-label="Screen time">
        {SCREEN_TIME_OPTIONS.map((o) => (
          <SelectableRow
            key={o.id}
            icon={ICONS[o.id]}
            iconBg={o.iconBg}
            title={o.title}
            selected={screenTime === o.id}
            onClick={() => setScreenTime(o.id)}
          />
        ))}
      </Item>
      <CtaRow>
        <ContinueButton onClick={nextStep} disabled={!screenTime} />
      </CtaRow>
    </>
  );
};

export default ScreenTimeStep;
